import { createModalStore } from '@/shared/lib/modal';

export const useIntroduceBoostersModalStore = createModalStore();
